import script from "./EventFormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventFormModal.vue?vue&type=script&setup=true&lang=ts"

import "./EventFormModal.vue?vue&type=style&index=0&id=bae4cb88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bae4cb88"]])

export default __exports__